import React from "react";
import { Stack, Box, Flex, Divider } from "@chakra-ui/react";
import { useLocation, Redirect } from "react-router";
import logoWithColors from "assets/images/rubix-logo.png";
import Image from "components/Image";
import { selectAuth } from "redux/slices/authSlice";
import { useTypedSelector } from "redux/hooks";

interface Props {
  children: React.ReactNode;
  forceAccessToken?: boolean;
}

const GuestLayout = ({ children, forceAccessToken }: Props) => {
  const location = useLocation<{ from: string }>();
  const { accessToken } = useTypedSelector(selectAuth);
  const isLoggedIn =
    location.pathname === "/" && (forceAccessToken || accessToken);
  const state = location.state;
  if (isLoggedIn) return <Redirect to={state?.from || "/home"} />;

  return (
    <Flex
      className="GuestLayout"
      h="100%"
      sx={{
        "@media screen and (max-height: 480px)": {
          h: "100%",
        },
      }}
    >
      <Stack
        direction="column"
        spacing="62px"
        h="100%"
        minW="294px"
        w="294px"
        p="41px 24px 0 24px"
        background="linear-gradient(193.05deg, #e0e0e0 4.45%, #C6C6C6 44.76%, #fff 98.52%)"
        pos="relative"
        display={["none", null, "flex"]}
      >
        <Image
          alignSelf={"center"}
          src={logoWithColors}
          h="128px"
          w="195px"
          alt="101Digital"
        />
      </Stack>
      <Stack direction="column" w="100%" h="100%">
        <Box display={["block", null, "none"]} w="100%" p="17px 15px 16px">
          <Image
            marginLeft={"auto"}
            marginRight={"auto"}
            h="128px"
            w="195px"
            src={logoWithColors}
            alt="101Digital"
          />
        </Box>
        <Divider
          display={["block", null, "none"]}
          w={"100%"}
          border="1px solid #C6C6C6"
        />
        {children}
      </Stack>
    </Flex>
  );
};

export default GuestLayout;
